import React from 'react'
import { connect } from 'cerebral-view-react'
import FlatButton from 'material-ui/FlatButton'
import { t } from '@billes/translator-client'
import CommmonDialog from 'components/common/dialog/common'
import Field from 'components/inputs/field'
import isValidForm from 'cerebral-module-forms/helpers/isValidForm'

const Dialog = ({ show, signals, form, password }) => {
  if (!show) {
    return null
  }

  const isValid = password.value && isValidForm(form)

  return (
    <CommmonDialog
      closeAction={() => {
        signals.app.hideNewPasswordDialog()
      }}
      renderActions={() => {
        return (
          <div>
            <FlatButton
              style={{ color: '#a8a8a8', fontSize: 13 }}
              label={t('common.save')}
              onClick={() => {
                signals.app.hideNewPasswordDialog()
                signals.user.saveAccount()
              }}
              disabled={!isValid}
            />
          </div>
        )
      }}
      renderContent={() => {
        return (
          <div>
            <Field
              path={`client.registrating.current.newPassword.password`}
              label={t('bus-client.field.password')}
              disabled={false}
              autoCompleteType='new-password'
            />
            <Field
              path={`client.registrating.current.newPassword.confirmPassword`}
              label={t('bus-client.field.confirmPassword')}
              disabled={false}
            />
          </div>
        )
      }}
    />
  )
}

export default connect({
  show: 'app.showNewPasswordDialog',
  form: 'client.registrating.current.newPassword',
  password: 'client.registrating.current.newPassword.password'
})(Dialog)



// WEBPACK FOOTER //
// ./src/components/common/dialog/newPassword/index.js